/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildMemoDto } from '../../models/child-memo-dto';
import { CreateChildMemoDto } from '../../models/create-child-memo-dto';

export interface UserChildMemoControllerCreateGuardianCounselingMemo$Params {
  childId: string;
  centerId: string;
  guardianId: string;
  teacherUserId: string;
      body: CreateChildMemoDto
}

export function userChildMemoControllerCreateGuardianCounselingMemo(http: HttpClient, rootUrl: string, params: UserChildMemoControllerCreateGuardianCounselingMemo$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildMemoDto>> {
  const rb = new RequestBuilder(rootUrl, userChildMemoControllerCreateGuardianCounselingMemo.PATH, 'post');
  if (params) {
    rb.query('childId', params.childId, {});
    rb.query('centerId', params.centerId, {});
    rb.query('guardianId', params.guardianId, {});
    rb.query('teacherUserId', params.teacherUserId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChildMemoDto>;
    })
  );
}

userChildMemoControllerCreateGuardianCounselingMemo.PATH = '/api/child-memo/user/guardian-counseling';
